<script lang="ts">
  // Winner mark next to a candidate: "✓ Winner (AP)" (AP call) · "✓ Winner" (decided by the count) · "✓ Projected" (our model).
  // compact: "✓ AP" / "✓" for tight rows (the full wording is in the tooltip and for screen readers).
  import { WIN_TEXT, WIN_TITLE, type WinKind } from '../../lib/race';
  let { kind, compact = false }: { kind: WinKind | undefined; compact?: boolean } = $props();
</script>

{#if kind}<span class="win" class:ap={kind === 'ap'} title={WIN_TITLE[kind]}><span aria-hidden="true">✓</span>{#if compact}{#if kind === 'ap'}<span aria-hidden="true">&nbsp;AP</span>{/if}<span class="sr">{WIN_TEXT[kind]}</span>{:else}&nbsp;{WIN_TEXT[kind]}{/if}</span>{/if}

<style>
  .win { color: var(--good); font-weight: 800; font-size: 0.82rem; white-space: nowrap; }
  .sr { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
</style>
